import React from 'react';
import PropTypes from 'prop-types';
import { FilterSection } from './filter_section';
import { FilterSelect } from './filters/filter_select';
import TranslationContainer from '../../../translation/translation_container';
import { Filters } from '../../../../constants/filter/filters';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';

function Technology(props) {
    const opened = props.opened || !!props.technologyValue;
    const technologyTranslationKey = FilterLabelTranslationKeys[Filters.TECHNOLOGY];
    return (
        <FilterSection
            opened={opened}
            resettable={props.resettable}
            onActionClick={props.onActionClick}
            headline="catalog-filters-section-headline-technology"
            containerModifier="technology"
        >
            <TranslationContainer
                targetProperties={{
                    tooltipContent: { translationKey: 'catalog-filter-technology-tooltip-text' },
                }}
            >
                <FilterSelect
                    name={Filters.TECHNOLOGY}
                    value={props.technologyValue}
                    options={props.technologyOptions}
                    labelTranslationKey={technologyTranslationKey}
                    provideAllTranslationKey="catalog-filters-technology-select-label-all"
                    onChange={props.onTechnologyChange}
                    onToolTipHover={() => props.onToolTipHover('Technology')}
                    provideAllOption={true}
                    tooltipContent="There should be some text here"
                    highlight={!props.technologyValue}
                    unavailableOptions = {[]}
                />
            </TranslationContainer>
        </FilterSection>
    );
}

Technology.propTypes = {
    technologyValue: PropTypes.string.isRequired,
    technologyOptions: PropTypes.array.isRequired,
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    onTechnologyChange: PropTypes.func.isRequired,
    onToolTipHover: PropTypes.func.isRequired,
};

export { Technology };
